import {
  Component,
  ElementRef,
  inject,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
  input,
} from '@angular/core';

import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailMailgunHtmlComponent } from '../email-html/email-mailgun-html.component';

@Component({
  selector: 'email-infobox',
  styleUrls: ['./email-infobox.component.less'],
  template: `<div [class]="getClassNames()">
    <table class="infobox-table" cellspacing="0" cellpadding="0">
      <tr>
        <td class="infobox-content web-infobox-markup">
          <mailgun-html #htmlContents [html]="contents()" />
        </td>
      </tr>
    </table>
  </div>`,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [EmailMailgunHtmlComponent],
})
export class EmailInfoboxComponent {
  public readonly contents = input<WrappedValue<string>>(undefined!);
  public readonly wrapperTag = input<keyof HTMLElementTagNameMap>();

  public readonly theme = input<'info' | 'warning' | 'success' | 'critical'>('warning');

  @ViewChild('htmlContents', { static: true, read: ElementRef })
  public htmlContents: ElementRef;

  private renderer = inject(Renderer2);

  public ngOnInit() {
    const wrapperTag = this.wrapperTag();
    if (wrapperTag) {
      const wrapper: HTMLElement = this.renderer.createElement(wrapperTag);
      const el: HTMLElement = this.htmlContents.nativeElement;

      el.parentElement?.appendChild(wrapper);
      wrapper.appendChild(el);
    }
  }
  public getClassNames() {
    return ['infobox', `infobox-${this.theme()}`];
  }
}
